module.exports = __webpack_public_path__ + "static/media/avatar.6ac01532.png";